import { CorrespondenceActionPartyDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadCorrespondenceActionParty = createAction(
  '[CorrespondenceActionParty] Load CorrespondenceActionParty'
);

export const loadCorrespondenceActionPartySuccess = createAction(
  '[CorrespondenceActionParty] Load CorrespondenceActionParty Success',
  props<{ correspondenceActionParty: CorrespondenceActionPartyDto[] }>()
);

export const loadCorrespondenceActionPartyFailure = createAction(
  '[CorrespondenceActionParty] Load CorrespondenceActionParty Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addCorrespondenceActionParty = createAction(
  '[CorrespondenceActionParty] Add CorrespondenceActionParty',
  props<{ newCorrespondenceActionParty: CorrespondenceActionPartyDto[] }>()
);

export const addCorrespondenceActionPartySuccess = createAction(
  '[CorrespondenceActionParty] Add CorrespondenceActionParty Success',
  props<{ newCorrespondenceActionParty: CorrespondenceActionPartyDto[] }>()
);

export const addCorrespondenceActionPartyFailure = createAction(
  '[CorrespondenceActionParty] Add CorrespondenceActionParty Failure',
  props<{ error: any }>()
);

/**
 * Update CorrespondenceActionParty Collection Actions
 */
export const updateCorrespondenceActionParty = createAction(
  '[CorrespondenceActionParty] Update CorrespondenceActionParty',
  props<{ updateCorrespondenceActionParty: CorrespondenceActionPartyDto[] }>()
);

export const updateCorrespondenceActionPartySuccess = createAction(
  '[CorrespondenceActionParty] Update CorrespondenceActionParty Success',
  props<{ updateCorrespondenceActionParty: CorrespondenceActionPartyDto[] }>()
);

export const updateCorrespondenceActionPartyFailure = createAction(
  '[CorrespondenceActionParty] Update CorrespondenceActionParty Failure',
  props<{ error: any }>()
);

/**
 * Remove CorrespondenceActionParty Collection Actions
 */
export const removeCorrespondenceActionParty = createAction(
  '[CorrespondenceActionParty] Remove CorrespondenceActionParty',
  props<{ ids: string[] }>()
);

export const removeCorrespondenceActionPartySuccess = createAction(
  '[CorrespondenceActionParty] Remove CorrespondenceActionParty Success',
  props<{ ids: string[] }>()
);

export const removeCorrespondenceActionPartyFailure = createAction(
  '[CorrespondenceActionParty] Remove CorrespondenceActionParty Failure',
  props<{ error: any }>()
);
